import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Badge, Box, Tab, Tabs } from "@mui/material";
import "./index.scss";
import MasterData from "../master-data";
import PurchaseOrder from "../purchase-order";
import GoodsReceiveNotes from "../goods-receive-notes";
// import { isViewAllowed, isDepartmentUserRole } from "../../utils/common-utils";
import { isViewAllowed, isBaseUserRole, hasDepartmentUserMasterAccess, hasViewerRole } from "../../utils/common-utils";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";
import InvoicesData from "../invoices-data";
import Reports from "../reports";
import Budget from "../budget";
import ApprovalConfig from "../approval-config";
import { getOfflineData, setOfflineData } from "../../utils/offline-services";
import CfApprovalMapping from "../cf-approval-mapping";
import MyPendingActions from "../my-pending-actions";
import VendorPos from "../purchase-order/vendor-pos";
import PurchaseRequisition from "../purchase-requisition";
import FinanceDashboard from "../dashboard";
import { buildDashboardCards } from "./dashboard-cards";

const DASHBOARD_TAB_VALUE = -1;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const Home = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const openTabIndex = searchParams.get("index");
  const [value, setValue] = useState(
    openTabIndex ? +openTabIndex : DASHBOARD_TAB_VALUE
  );
  const [isFinanceUser, setIsFinanceUser] = useState(false);
  const [isVendorUser, setVendorUser] = useState(false);
  const [userValue, setUserValue] = useState(
    openTabIndex ? +openTabIndex : DASHBOARD_TAB_VALUE
  );
  const [vendorValue, setVendorValue] = useState(
    openTabIndex ? +openTabIndex : DASHBOARD_TAB_VALUE
  );
  const [user, setUser] = useState({});
  const [noOfPendingRequest, setNoOfPendingRequest] = useState(0);

  const handleChange = (event, newValue) => {
    if (newValue === 0) {
      setSearchParams({
        index: newValue,
      });
    } else if (newValue === 1) {
      setSearchParams({
        index: newValue,
        subIndex: 2,
      });
    } else if (newValue === 2) {
      setSearchParams({
        index: newValue,
        subIndex: 0,
      });
    } else if (newValue === 3) {
      setSearchParams({
        index: newValue,
        subIndex: 6,
      });
    } else if (newValue === 4) {
      setSearchParams({
        index: newValue,
        subIndex: 5,
      });
    } else if (newValue === 6) {
      setSearchParams({
        index: newValue,
        subIndex: 4,
      });
    } else {
      setSearchParams({
        index: newValue,
        subIndex: 0,
      });
    }

    setValue(newValue);
  };
  const userHandleChange = (event, newValue) => {
    {
      if (newValue === 0) {
        setSearchParams({
          index: newValue,
        });
      } else if (newValue === 1) {
        setSearchParams({
          index: newValue,
          subIndex: 0,
        });
      } else if (newValue === 2) {
        setSearchParams({
          index: newValue,
          subIndex: 6,
        });
      } else if (newValue === 3) {
        setSearchParams({
          index: newValue,
          subIndex: 5,
        });
      } else if (newValue === 4) {
        setSearchParams({
          index: newValue,
          subIndex: 4,
        });
      } else {
        setSearchParams({
          index: newValue,
          subIndex: 0,
        });
      }
      setUserValue(newValue);
    }
  };
  const vendorHandleChange = (event, newValue) => {
    if (newValue === 1) {
      setSearchParams({
        index: newValue,
        subIndex: 4,
      });
    } else {
      setSearchParams({
        index: newValue,
        subIndex: 0,
      });
    }

    setVendorValue(newValue);
  };
  useEffect(() => {
    const role = user?.role?.toUpperCase();
    if (
      role?.includes("FINANCE") ||
      role?.includes("ADMIN") ||
      role?.includes("BUDGET")
    ) {
      setIsFinanceUser(true);
    }
    if (role?.includes("VENDOR")) {
      setVendorUser(true);
    }
  }, [user]);

  useEffect(() => {
    setUser(getOfflineData("user"));
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VIEWER_ROLES}`
    )
      .then((response) => {
        if (response?.message) {
          return;
        }
        const storedUser = getOfflineData("user") || {};
        const userRights = storedUser?.userRights || {};
        const updatedUser = {
          ...storedUser,
          viewerRoles: {
            poViewer: !!response?.poViewer,
            budgetViewer: !!response?.budgetViewer,
          },
          userRights: response?.budgetViewer
            ? { ...userRights, budget: { ...(userRights.budget || {}), view: true } }
            : storedUser?.userRights,
        };
        setOfflineData("user", updatedUser);
        setUser(updatedUser);
      })
      .catch(() => {});
  }, []);
  const financeTabs = () => {
    const masterRole = user?.role?.toUpperCase();
    return (
      <div>
        <div className="tabs-section">
          <Box
            sx={{
              width: "100%",
              backgroundColor: "white",
              display: "flex",
            }}
          >
            <div style={{ minWidth: "fit-content" }}>
              <Tabs
                variant="scrollable"
                value={value}
                onChange={handleChange}
                sx={{
                  background: "#ffffff",
                  borderBottom: "1px solid #DDE2EC",
                  minHeight: 48,
                  "& .MuiTabs-indicator": { display: "none" },
                  "& .MuiTab-root": {
                    color: "#5B6E8A",
                    minHeight: 48,
                    minWidth: "unset",
                    padding: "5px 11px",
                    borderRadius: "6px",
                    margin: "0 1px",
                    textTransform: "none",
                  },
                  "& .Mui-selected": {
                    color: "#ffffff !important",
                    background: "#005F35",
                  },
                }}
                TabIndicatorProps={{ sx: { display: "none" } }}
              >
                <Tab
                  value={DASHBOARD_TAB_VALUE}
                  label="Dashboard"
                  className={value == DASHBOARD_TAB_VALUE && "active-tab"}
                  sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                />
                <Tab
                  value={0}
                  sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      My Pending Actions
                      {noOfPendingRequest > 0 && (
                        <span style={{
                          backgroundColor: "#005F35",
                          color: "#fff",
                          fontSize: "10px",
                          fontWeight: 600,
                          padding: "2px 5px",
                          borderRadius: "10px",
                          lineHeight: 1.4,
                        }}>
                          {noOfPendingRequest}
                        </span>
                      )}
                    </span>
                  }
                  className={value == 0 && "active-tab"}
                />
                <Tab
                  value={1}
                  label="Budgets"
                  className={value == 1 && "active-tab"}
                  style={{ height: "32px" }}
                  sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important"}}
                />
                <Tab value={2} label="PR" className={value == 2 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}/>
                <Tab value={3} label="PO" className={value == 3 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                <Tab
                  value={4}
                  label="Goods Receive Notes"
                  className={value == 4 && "active-tab"}
                  sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                />

                <Tab
                  value={5}
                  label="Advance Payment Details"
                  className={value == 5 && "active-tab"}
                  sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                />
                <Tab value={6} label="Reports" className={value == 6 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                {(masterRole?.includes("FINANCE") ||
                  masterRole?.includes("ADMIN")) && (
                  <Tab value={7} label="Masters" className={value == 7 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important"}} />
                )}

                {user?.properties?.finance?.approvalConfigRights && (
                  <Tab
                    value={8}
                    label="Approval Config"
                    className={value == 8 && "active-tab"}
                    sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                )}
                {user?.properties?.finance?.cfMappingRights && (
                  <Tab
                    value={9}
                    label="CF Approval Mapping"
                    className={value == 9 && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                )}
              </Tabs>
            </div>
            <div
              style={{ width: "100%", borderBottom: "1px solid #DDE2EC" }}
            ></div>
          </Box>
        </div>
        <TabPanel value={value} index={DASHBOARD_TAB_VALUE}>
          <FinanceDashboard
            cards={buildDashboardCards({ branch: "finance", user, masterRole })}
            onViewTab={(tabValue) => handleChange(null, tabValue)}
          />
        </TabPanel>
        <TabPanel value={value} index={0}>
          <MyPendingActions
            getCountOfPendingRequest={getCountOfPendingRequest}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {isViewAllowed("budget") ? <Budget /> : "No access to view budgets"}
        </TabPanel>

        <TabPanel value={value} index={2}>
          <PurchaseRequisition />
        </TabPanel>

        <TabPanel value={value} index={3}>
          {isViewAllowed("po") ? (
            <PurchaseOrder />
          ) : (
            "No access to view Purchase orders "
          )}
        </TabPanel>
        <TabPanel value={value} index={4}>
          {isViewAllowed("grn") ? (
            <GoodsReceiveNotes />
          ) : (
            "No access to view grn"
          )}
        </TabPanel>

        <TabPanel value={value} index={5}>
          {isViewAllowed("advancePayment") ? (
            <InvoicesData />
          ) : (
            "No access to Advance Payment"
          )}
        </TabPanel>
        <TabPanel value={value} index={6}>
          <Reports />
        </TabPanel>
        <TabPanel value={value} index={7}>
          {isViewAllowed("master_data") ? (
            <MasterData />
          ) : (
            "No access to Master"
          )}
        </TabPanel>
        {user?.properties?.finance?.approvalConfigRights && (
          <TabPanel value={value} index={8}>
            <ApprovalConfig />
          </TabPanel>
        )}
        {user?.properties?.finance?.cfMappingRights && (
          <TabPanel value={value} index={9}>
            <CfApprovalMapping />
          </TabPanel>
        )}
      </div>
    );
  };
  const getCountOfPendingRequest = (totalCount) => {
    setNoOfPendingRequest(totalCount);
  };

  return (
    <div className="finance-v2-home-container">
      {isFinanceUser ? (
        financeTabs()
      ) : isVendorUser ? (
        <div>
          <div className="tabs-section">
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              <div style={{ minWidth: "fit-content" }}>
                <Tabs
                  variant="scrollable"
                  value={vendorValue}
                  onChange={vendorHandleChange}
                  sx={{
                    background: "#ffffff",
                    borderBottom: "1px solid #DDE2EC",
                    minHeight: 48,
                    "& .MuiTabs-indicator": { display: "none" },
                    "& .MuiTab-root": {
                      color: "#5B6E8A",
                      fontSize: "0.78rem",
                      fontWeight: 500,
                      minHeight: 48,
                      minWidth: "unset",
                      padding: "5px 11px",
                      borderRadius: "6px",
                      margin: "0 1px",
                      textTransform: "none",
                    },
                    "& .Mui-selected": {
                      color: "#ffffff !important",
                      background: "#005F35",
                      fontWeight: "600 !important",
                    },
                  }}
                  TabIndicatorProps={{ sx: { display: "none" } }}
                >
                  <Tab
                    value={DASHBOARD_TAB_VALUE}
                    label="Dashboard"
                    className={vendorValue == DASHBOARD_TAB_VALUE && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                  <Tab
                    value={0}
                    label="PO"
                    className={vendorValue == 0 && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                  <Tab
                    value={1}
                    label="Goods Receive Notes"
                    className={vendorValue == 1 && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                  <Tab
                    value={2}
                    label="Reports"
                    className={vendorValue == 2 && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                </Tabs>
              </div>
              <div
                style={{ width: "100%", borderBottom: "1px solid #DDE2EC" }}
              ></div>
            </Box>
          </div>

          <TabPanel value={vendorValue} index={DASHBOARD_TAB_VALUE}>
            <FinanceDashboard
              cards={buildDashboardCards({ branch: "vendor", user })}
              onViewTab={(tabValue) => vendorHandleChange(null, tabValue)}
            />
          </TabPanel>
          <TabPanel value={vendorValue} index={0}>
            {isViewAllowed("po") ? (
              <VendorPos />
            ) : (
              "No access to view Purchase orders "
            )}
          </TabPanel>
          <TabPanel value={vendorValue} index={1}>
            {isViewAllowed("grn") ? (
              <GoodsReceiveNotes />
            ) : (
              "No access to view grn"
            )}
          </TabPanel>
          <TabPanel value={vendorValue} index={2}>
            <Reports />
          </TabPanel>
        </div>
      ) : (
        <div>
          <div className="tabs-section">
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              <div style={{ minWidth: "fit-content" }}>
                <Tabs
                  variant="scrollable"
                  value={userValue}
                  onChange={userHandleChange}
                  sx={{
                    background: "#ffffff",
                    borderBottom: "1px solid #DDE2EC",
                    minHeight: 48,
                    "& .MuiTabs-indicator": { display: "none" },
                    "& .MuiTab-root": {
                      color: "#5B6E8A",
                      fontSize: "0.78rem",
                      fontWeight: 500,
                      minHeight: 48,
                      minWidth: "unset",
                      padding: "5px 11px",
                      borderRadius: "6px",
                      margin: "0 1px",
                      textTransform: "none",
                    },
                    "& .Mui-selected": {
                      color: "#ffffff !important",
                      background: "#005F35",
                      fontWeight: "600 !important",
                    },
                  }}
                  TabIndicatorProps={{ sx: { display: "none" } }}
                >
                  <Tab
                    value={DASHBOARD_TAB_VALUE}
                    label="Dashboard"
                    className={userValue == DASHBOARD_TAB_VALUE && "active-tab"}
                    sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                  <Tab
                    value={0}
                    label={
                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        My Pending Actions
                        {noOfPendingRequest > 0 && (
                          <span style={{
                            backgroundColor: "#005F35",
                            color: "#fff",
                            fontSize: "10px",
                            fontWeight: 600,
                            padding: "2px 5px",
                            borderRadius: "10px",
                            lineHeight: 1.4,
                          }}>
                            {noOfPendingRequest}
                          </span>
                        )}
                      </span>
                    }
                    className={userValue == 0 && "active-tab"}
                    sx={{ paddingX: 3,fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                  />
                  {hasViewerRole("budget") && (
                    <Tab value={9} label="Budgets" className={userValue == 9 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  )}
                  {/* <Tab value={1} label="PR" className={userValue == 1 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} /> */}
                  {/* Plain "user" has no PR access (old-system behaviour) */}
                  {!isBaseUserRole() && (
                    <Tab value={1} label="PR" className={userValue == 1 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  )}
                  <Tab value={2} label="PO" className={userValue == 2 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  <Tab value={3} label="Goods Receive Notes" className={userValue == 3 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important"}} />
                  <Tab value={4} label="Advance Payment Details" className={userValue == 4 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  <Tab value={5} label="Reports" className={userValue == 5 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  {user?.properties?.finance?.approvalConfigRights && (
                    <Tab value={6} label="Approval Config" className={userValue == 6 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  )}
                  {user?.properties?.finance?.cfMappingRights && (
                    <Tab value={7} label="CF Approval Mapping" className={userValue == 7 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  )}
                  {/* {isDepartmentUserRole() && ( */}
                  {hasDepartmentUserMasterAccess() && (
                    <Tab value={8} label="Masters" className={userValue == 8 && "active-tab"} sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                  )}
                </Tabs>
              </div>
              <div
                style={{ width: "100%", borderBottom: "1px solid #DDE2EC" }}
              ></div>
            </Box>
          </div>

          <TabPanel value={userValue} index={DASHBOARD_TAB_VALUE}>
            <FinanceDashboard
              cards={buildDashboardCards({ branch: "regular", user })}
              onViewTab={(tabValue) => userHandleChange(null, tabValue)}
            />
          </TabPanel>
          <TabPanel value={userValue} index={0}>
            <MyPendingActions
              getCountOfPendingRequest={getCountOfPendingRequest}
            />
          </TabPanel>
          {/* <TabPanel value={userValue} index={1}>
            <PurchaseRequisition />
          </TabPanel> */}
          {!isBaseUserRole() && (
            <TabPanel value={userValue} index={1}>
              <PurchaseRequisition />
            </TabPanel>
          )}
          <TabPanel value={userValue} index={2}>
            {isViewAllowed("po") ? (
              <PurchaseOrder />
            ) : (
              "No access to view Purchase orders "
            )}
          </TabPanel>
          <TabPanel value={userValue} index={3}>
            {isViewAllowed("grn") ? (
              <GoodsReceiveNotes />
            ) : (
              "No access to view grn"
            )}
          </TabPanel>
          <TabPanel value={userValue} index={4}>
            {isViewAllowed("advancePayment") ? (
              <InvoicesData />
            ) : (
              "No access to Advance Payment"
            )}
          </TabPanel>
          <TabPanel value={userValue} index={5}>
            <Reports />
          </TabPanel>
          {user?.properties?.finance?.approvalConfigRights && (
            <TabPanel value={userValue} index={6}>
              <ApprovalConfig />
            </TabPanel>
          )}
          {user?.properties?.finance?.cfMappingRights && (
            <TabPanel value={userValue} index={7}>
              <CfApprovalMapping />
            </TabPanel>
          )}
          {/* {isDepartmentUserRole() && ( */}
          {hasDepartmentUserMasterAccess() && (
            <TabPanel value={userValue} index={8}>
              {isViewAllowed("master_data") ? (
                <MasterData />
              ) : (
                "No access to Master"
              )}
            </TabPanel>
          )}
          {hasViewerRole("budget") && (
            <TabPanel value={userValue} index={9}>
              <Budget />
            </TabPanel>
          )}
        </div>
      )}
    </div>
  );
};

export default Home;
